import React from 'react';
import { useSubscription } from '../context/SubscriptionContext';
import SubscriptionPlan from '../components/SubscriptionPlan';
import { subscriptionTiers } from '../services/subscriptionService';
import '../styles/SubscriptionPage.css';

const SubscriptionPage = () => {
  const { subscription, loading, upgradeSubscription } = useSubscription();

  const handleUpgrade = async (tier) => {
    try {
      if (tier === 'FREE') {
        alert('You are already on the Free tier!');
        return;
      }
      
      // For now, show what the upgrade would cost
      const tierInfo = subscriptionTiers[tier];
      const confirmed = window.confirm(
        `Upgrade to ${tierInfo.name} for $${tierInfo.price}/month?\n\n` +
        `You'll get:\n` +
        `• ${tierInfo.propertyAnalyses === -1 ? 'Unlimited' : tierInfo.propertyAnalyses} property analyses\n` +
        `• ${tierInfo.chatMessages === -1 ? 'Unlimited' : tierInfo.chatMessages} chat messages\n` +
        `• ${tierInfo.features.join('\n• ')}\n\n` +
        `Note: This is a demo. Real Stripe integration coming soon!`
      );
      
      if (confirmed) {
        alert(`Thanks for your interest in ${tierInfo.name}! \n\nReal payment processing will be available soon. Your subscription limits are currently managed by your existing system.`);
      }
    } catch (error) {
      console.error('Error upgrading subscription:', error);
      alert('Failed to upgrade subscription. Please try again.');
    }
  };

  if (loading) {
    return (
      <div className="subscription-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading subscription information...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="subscription-page">
      <div className="subscription-header">
        <h1>Choose Your Plan</h1>
        <p>Select the plan that best fits your property investment needs</p>
      </div>

      <div className="subscription-plans">
        {Object.entries(subscriptionTiers).map(([tierKey, tierData]) => (
          <SubscriptionPlan
            key={tierKey}
            tier={tierKey}
            isCurrentPlan={subscription?.tier === tierKey}
            onUpgrade={handleUpgrade}
          />
        ))}
      </div>

      <div className="subscription-footer">
        <div className="faq-section">
          <h3>Frequently Asked Questions</h3>
          
          <div className="faq-item">
            <h4>Can I change my plan anytime?</h4>
            <p>Yes, you can upgrade or downgrade your plan at any time. Changes take effect immediately.</p>
          </div>
          
          <div className="faq-item">
            <h4>What happens if I exceed my limits?</h4>
            <p>You'll be prompted to upgrade your plan. Your account won't be suspended, but additional usage may be restricted.</p>
          </div>
          
          <div className="faq-item">
            <h4>Is there a free trial?</h4>
            <p>Yes! The Free tier gives you 5 property analyses and 20 chat messages per month to try our features.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPage;